import { CustomDashboardProps } from "../utils/types";

import { dashboard as keyMetricsOverview } from "./key-metrics-overview";
import { dashboard as projectWiseAllocations } from "./project-wise-allocations";
import { dashboard as operations } from "./operations";
import { dashboard as operationsRevenueTrend } from "./operations-revenue-trend";
import { dashboard as operationsRevenueCostAnalysis } from "./operations-revenue-cost-analysis";
import { dashboard as salesPipelineHealth } from "./sales-pipeline-health";
import { dashboard as winLossAnalysis } from "./win-loss-analysis";
import { dashboard as operationsUtilizationAnalysis } from "./operations-utilization-analysis";
import { dashboard as financialExport } from "./financial-export";
import { dashboard as revenueBilledHours } from "./revenue-billed-hours";

type DashboardObj = {
  [key: number]: CustomDashboardProps;
};

export const customDashboards: DashboardObj = {
  15: keyMetricsOverview,
  18: projectWiseAllocations,
  58: operations,
  62: financialExport,
  88: operationsRevenueTrend,
  95: operationsRevenueCostAnalysis,
  96: operationsUtilizationAnalysis,
  97: salesPipelineHealth,
  98: revenueBilledHours,
  100: winLossAnalysis,
};
